import { useState, useEffect } from 'react'
import { Grid } from '@mui/material'

import Dialog from './Dialog'
import InputField from './InputField'
import { titlesImpostazioni } from '../settings/settings'

const DialogImpostazioniGoogleMapsTest = ({
  open,
  handleClose,
  triggerFunction,
}) => {
  const [testMapsA, setTestMapsA] = useState()
  const [testMapsB, setTestMapsB] = useState()

  useEffect(() => {
    setTestMapsA()
    setTestMapsB()
  }, [open])

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      triggerFunction={() => triggerFunction(testMapsA, testMapsB)}
      title={titlesImpostazioni.titleGoogleMapsTest}
      textConfirm='Test'
    >
      Prima di procedere, assicurati di aver salvato le impostazioni nella
      schermata precedente.
      <br />
      <br />
      <Grid container alignItems='center' spacing={2} sx={{ width: '100%' }}>
        <Grid size={12}>
          <InputField
            id='test-maps-A'
            label='Partenza'
            value={testMapsA}
            onChange={setTestMapsA}
          />
        </Grid>
        <Grid size={12}>
          <InputField
            id='test-maps-B'
            label='Destinazione'
            value={testMapsB}
            onChange={setTestMapsB}
          />
        </Grid>
      </Grid>
    </Dialog>
  )
}

export default DialogImpostazioniGoogleMapsTest
